import React from 'react'
import Grid from '@mui/material/Grid'

import Typography from '@mui/material/Typography'
import { Delete, Edit, SmsOutlined } from '@mui/icons-material'
import { StyledCard, DeleteCorner, EditCorner, LogoBox } from './styles'
import { ModalType } from '../../types'

interface Props {
   handleModalType: (type: ModalType) => void
}

export default function CoopCard({ handleModalType }: Props) {
   return (
      <Grid size={{ xs: 12, sm: 4, md: 4, lg: 3, xl: 2 }}>
         <StyledCard>
            <DeleteCorner onClick={() => handleModalType('delete')}>
               <Delete />
            </DeleteCorner>
            <EditCorner onClick={() => handleModalType('edit')}>
               <Edit />
            </EditCorner>
            <LogoBox>
               <SmsOutlined color="primary" sx={{ height: 25, width: 'auto' }} />
               <Typography color="primary" variant="h6">
                  SMS Api
               </Typography>
            </LogoBox>
         </StyledCard>
      </Grid>
   )
}
